module.exports = __webpack_public_path__ + "img/map.b2622f15.png";